<app-resolution-warning></app-resolution-warning>
<router-outlet></router-outlet>